<template>
  <div class="w-full">
    <div
      class="flex flex-row items-center content-center align-bottom space-x-4 mt-4"
    >
      <div class="space-y-1 flex-1">
        <label for="network_select" class="text-sm text-gray-500 text-medium"
          >Filter by network</label
        >
        <select
          id="network_select"
          name="network_select"
          class="block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md"
          v-model="filterNetworkId"
        >
          <option
            v-for="network in sortNetworksArrayByAmountOfSales"
            :value="network.id"
            v-bind:key="network.id"
            >{{ network.purchases }} - {{ network.name }}</option
          >
        </select>
      </div>
      <button
        class="bg-red-600 text-white rounded-lg px-3 py-1.5"
        v-if="shouldShowDeletedButton"
        v-on:click="deleteSelectedSales"
      >
        Delete Selected Sales
      </button>
    </div>

    <div
      class="mt-4 bg-gray-50 border border-gray-200 flex items-center content-center justify-center py-24"
      v-if="polling"
    >
      <DotPulse />
    </div>

    <ul class="mt-4 space-y-2 divide-gray-200" v-if="!polling">
      <li
        v-for="sale in sales"
        v-bind:key="sale.id"
        v-on:click="openViewSaleModal(sale)"
      >
        <div
          class="bg-white rounded-md overflow-hidden px-4 py-4 sm:px-6 flex flex-row items-center content-center group relative cursor-pointer"
        >
          <input
            name="displayPricingDefault"
            id="displayPricingDefault"
            type="checkbox"
            class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded focus:outline-none mr-4"
            v-model="selectedIds[sale.id]"
            @click.stop
          />
          <div class="flex-1">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-800 truncate">
                {{ sale.video.title }}
              </p>
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex">
                <div
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 space-x-1"
                >
                  <span class="flex-shrink-0 h-5 w-5 flex items-center">
                    <i class="fad fa-building"></i>
                  </span>
                  <p>{{ sale.network.name }}</p>
                </div>
                <div
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6 space-x-1"
                >
                  <span class="flex-shrink-0 h-5 w-5 flex items-center">
                    <i class="fas fa-user"></i>
                  </span>
                  <p>
                    {{ sale.owner.name }}
                    <i
                      class="fa-regular fa-circle-exclamation ml-1 text-red-600"
                      v-if="sale.owner.w9_timestamp == null"
                      v-tippy
                      title="User has not submitted a W-9 form yet."
                    ></i>
                  </p>
                </div>
                <div
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6 space-x-1"
                >
                  <span class="flex-shrink-0 h-5 w-5 flex items-center">
                    <i class="fas fa-coins"></i>
                  </span>
                  <p>${{ sale.price }}</p>
                </div>
                <div
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6 space-x-1"
                  v-if="sale.video.credit !== null"
                >
                  <span class="flex-shrink-0 h-5 w-5 flex items-center">
                    <i class="fa-solid fa-wallet"></i>
                  </span>
                  <p>{{ sale.video.credit }} credits</p>
                </div>

                <!-- <div
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6"
                  v-tippy
                  title="Invoice Reference"
                >
                  <span class="flex-shrink-0 h-5 w-5 flex items-center">
                    <i class="fad fa-file-invoice"></i>
                  </span>
                  <p>{{ sale.invoice_number }}</p>
                </div> -->
              </div>

              <div
                class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 space-x-1"
              >
                <!-- Heroicon name: solid/calendar -->
                <span class="flex-shrink-0 h-5 w-5 flex items-center">
                  <i class="fad fa-calendar-check"></i>
                </span>
                <p>
                  Purchased on
                  <span
                    >{{ sale.created_at | displayLocalDateTime("M/D/YYYY") }}
                    at
                    {{ sale.created_at | displayLocalDateTime("h:mm a") }}</span
                  >
                </p>
              </div>
            </div>
          </div>
          <!-- <div
            class="absolute top-0 left-0 w-full h-full opacity-0 group-hover:opacity-100 flex flex-row justify-end items-center content-center align-middle p-4 backdrop-filter backdrop-brightness-75 backdrop-opacity-80 backdrop-blur-sm transition select-none"
          >
            <button
              class="px-2 py-1.5 bg-blue-600 rounded-lg text-white shadow-md"
            >
              Finalize Sale
            </button>
          </div> -->
        </div>
      </li>
      <li v-if="polling">
        <div class="flex items-center justify-center py-5">
          <h1 class="text-2xl">
            <i class="fa fa-circle-notch fa-spin text-black"></i>
          </h1>
        </div>
      </li>
    </ul>
    <ApproveVideoSaleModal />
  </div>
</template>

<script>
import * as Config from "@/config";

import Dropdown from "@/components/partials/Dropdown";
import ApproveVideoSaleModal from "@/screens/admin/modals/ApproveVideoSaleModal";
import DotPulse from "@/components/Loaders/DotPulse";
import { EventBus } from "@/utils/events";

export default {
  name: "HelloWorld",
  data() {
    return {
      sales: [],
      networks: [],

      polling: true,

      filterNetworkIndex: null,
      filterNetworkId: null,

      // filteredSales: []
      selectedIds: {}
    };
  },
  components: {
    Dropdown,
    ApproveVideoSaleModal,
    DotPulse
  },
  mounted() {
    this.getNetworkSales();
    this.getSales();

    this.$nextTick(
      function() {
        this.$eventBus.$on("admin-approve-sale-refresh-data", this.updateSales);
      }.bind(this)
    );
  },
  methods: {
    async updateSales() {
      this.getNetworkSales();
      this.getSales();
    },
    async getNetworkSales() {
      let res = await this.$http.get(
        Config.apiPath + "/api/v2/admin/sales/latest/networks?status=pending"
      );
      this.networks = res.data.networks;
      this.selectedIds = {};
    },
    async getSales() {
      this.polling = true;
      let res = await this.$http.get(
        Config.apiPath +
          "/api/v2/admin/sales/latestbynetwork?status=pending&networkId=" +
          this.filterNetworkId
      );
      this.sales = res.data;

      this.polling = false;
      this.selectedIds = {};
    },
    openViewSaleModal(data) {
      this.$eventBus.$emit("admin-approve-sale-open-modal", data);
    },
    getFilteredDeletedSales() {
      return Object.keys(this.selectedIds).filter(id => {
        return this.selectedIds[id] == true;
      });
    },
    async deleteSelectedSales() {
      let result = await this.$swal({
        title: "Continue?",
        text:
          "You are about to delete the selected sales? This action cannot be undone.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete them."
      });
      if (result.isConfirmed) {
        let res = await this.$http.post(
          Config.apiPath + "/api/v2/admin/sales/delete/bulk",
          {
            idsToRemove: this.getFilteredDeletedSales()
          }
        );
        this.getSales();
      }
    }
  },
  computed: {
    sortNetworksArrayByAmountOfSales() {
      return this.networks.sort((a, b) => {
        return b.purchases - a.purchases;
      });
    },
    shouldShowDeletedButton() {
      let filtered = this.getFilteredDeletedSales();
      console.log(filtered);
      return filtered.length > 0;
    }
  },
  watch: {
    filterNetworkId: function() {
      this.getSales();
    }
  }
};
</script>
